export enum Attributions {
    No = 12,
    HealthPlan = 13,
    PatientList = 14
}